import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITransactionCoordinatorEvent } from "../../types/transaction-coordinator";

export interface EventState {
    loading: boolean;
    loadingError: string;
    events: ITransactionCoordinatorEvent[];
}

const initialState: EventState = {
    loading: false,
    loadingError: "",
    events: []
};

const eventSlice = createSlice({
    name: "event",
    initialState,
    reducers: {
        setEventLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setEventLoadingError: (state, action: PayloadAction<string>) => {
            state.loadingError = action.payload;
        },
        populateEvents: (state, action: PayloadAction<ITransactionCoordinatorEvent[]>) => {
            state.events = [...action.payload];
        },
        addEvent: (state, action: PayloadAction<ITransactionCoordinatorEvent>) => {
            state.events.push(action.payload);
        }
    }
});

export const selectEvents = (state: { event: EventState }) => state.event.events;

// Export actions
export const { setEventLoading, setEventLoadingError, populateEvents, addEvent } =
    eventSlice.actions;

export default eventSlice.reducer;
